import { AfterViewInit, Component, ContentChild, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';

@Component({
  selector: 'viewer-pdf',
  templateUrl: './viewer-pdf.component.html',
  host: { 'hostID': crypto.randomUUID().toString() } // evitar aviso "collision ID"
})
export class ViewerPdfComponent implements OnInit, AfterViewInit {
  public page = 1;
  public zoom = 1;
  public pdf: any;
  public numPages: number;
  public src;
  public base_64_string: string;
  public showPdf = false;
  public pdfViewer;

  @Input() base64PdfModal; // si se va a usar en la ventana actual, dentro del modal

  constructor (private element: ElementRef) {}

  ngOnInit() {
    if (this.base64PdfModal || localStorage.getItem('base64')) {
      this.showPdf = true;
      this.base_64_string = this.base64PdfModal || localStorage.getItem('base64');
      this.getPdf();
    }
  }

  ngAfterViewInit() {
    this.pdfViewer = this.element.nativeElement.querySelector('.pdfViewer');
  }

  getPdf(){
    this.src = this._base64ToArrayBuffer(this.base_64_string);

    if (!this.base64PdfModal) {
      localStorage.removeItem('base64');
    }
  }

  _base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  pagechanging(e: any){
    //this.page = e.pageNumber;
  }

  incrementPage(amount:number){
    if(this.page == 1 && amount == -1){
      return;
    }
    this.page += amount;
  }

  incrementZoom(amount:number){
    this.zoom += amount;
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    this.pdf = pdf;
    this.numPages = pdf.numPages;
  }

  viewPages(page:number) {
    if(page === 1) {
      this.pdfViewer.classList.remove('twoPages');
      this.zoom = 1;
    } else {
      this.pdfViewer.classList.add('twoPages');
      this.zoom = 0.8;
    }
  }
}
